import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPlus } from "@fortawesome/free-solid-svg-icons"
import CollapsibleCardV2 from "../basics/interface/CollapsibleCardV2"
import SoldeBadge, { isSolde } from "./SoldeBadge"
import TransactionV2 from "./TransactionV2"
import { generalStyles } from "../styles/styles"

/**
 * Carte « Transactions » commune aux 3 fiches (modèle : atelier).
 * Collapsible, coche « complété » quand le solde est à zéro, SoldeBadge dans
 * l'en-tête, liste de TransactionV2 et bouton d'ajout (chaque fiche fournit
 * son modal via `onAdd`).
 *
 * - `canEdit`   : droits d'édition de la fiche — false masque l'ajout et
 *                 verrouille toutes les lignes.
 * - `locked`    : fiche close — tout verrouillé, ajout masqué.
 * - `lockedFor` : (tx) => bool, verrou par transaction propre au domaine
 *                 (optionnel).
 * - `addDisabled` : bouton d'ajout désactivé (ex. atelier : déjà soldé).
 * - `open`/`onToggle` : mode contrôlé de CollapsibleCardV2 (optionnel).
 * - `onChange(idx, key, value)`, `onDelete(idx)`, `onDeleteDocument`,
 *   `onGenerate`, `onUploadFacture` : passés à TransactionV2 tels quels.
 */
const TransactionsCardV2 = ({
	transactions,
	restePayer,
	canEdit = true,
	locked = false,
	lockedFor = null,
	// (tx) → motif (ligne figée : pas de suppression, régulariser) ou null.
	nonSupprimable = null,
	onAdd,
	addDisabled = false,
	onChange,
	onDelete,
	onDeleteDocument,
	onGenerate,
	onUploadFacture = null,
	open,
	onToggle,
	module = null,
	entite = null,
	// A4 : annulation d'un encaissement terrain (fiche dépannage).
	onAnnulerEncaissement = null,
	// Jordan 15.10 (fiche dépannage) : (tx) → {modifiable, raison} pour la
	// date ; (tx) → droits par champ (Q17) ; (tx) → motif de refus
	// d'annulation.
	datation = null,
	champs = null,
	refusAnnulation = null,
}) => (
	<CollapsibleCardV2
		title="Transactions"
		completed={isSolde(restePayer)}
		right={<SoldeBadge reste={restePayer} />}
		open={open}
		onToggle={onToggle}
	>
		{/* gap 20 = l'espacement historique des lignes atelier (marginTop). */}
		<div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
			{transactions.map((tx, i) => (
				<TransactionV2
					// Une transaction fraîchement ajoutée n'a pas encore d'id.
					key={tx.id === null ? `new_${i}` : `tx_${tx.id}`}
					index={i}
					transaction={tx}
					onChange={onChange}
					onDelete={onDelete}
					suppressionBloquee={
						nonSupprimable ? nonSupprimable(tx) : null
					}
					onDeleteDocument={onDeleteDocument}
					onGenerate={onGenerate}
					onUploadFacture={onUploadFacture}
					locked={
						locked ||
						!canEdit ||
						(lockedFor ? !!lockedFor(tx) : false)
					}
					module={module}
					entite={entite}
					onAnnulerEncaissement={onAnnulerEncaissement}
					datation={datation ? datation(tx) : null}
					champs={champs ? champs(tx) : null}
					refusAnnulation={
						refusAnnulation ? refusAnnulation(tx) : null
					}
				/>
			))}
			{canEdit && !locked && (
				<button
					type="button"
					style={generalStyles.addBtn}
					onClick={onAdd}
					disabled={addDisabled}
				>
					<FontAwesomeIcon icon={faPlus} /> Ajouter une transaction
				</button>
			)}
		</div>
	</CollapsibleCardV2>
)

export default TransactionsCardV2
